import { Button, Grid } from '@mui/material';
import React, { useEffect } from 'react';
import './SupportSheet.scss';
import { useDispatch, useSelector } from 'react-redux';
import SupportSheetBiefInformation from './SupportSheetBiefInformation';
import { resetDataChange, setBrokerEmails, setChartererBrokerContactPrinciple, setCurrentFixture, setOwnerBrokerContactPrinciple, setSupportSheet, SupportSheetSelector } from './reducers/SupportSheetReducer';
import { MarketInfoType } from '../MarketInfo/models/MarketInfoQueryModel';
import _ from 'lodash';
import Utility from '../../app/utility';
import SupportSheetModel from './models/SupportSheetModel';
import SupportSheetPreVoyage from './SupportSheetPreVoyage';
import SupportSheetOnVoyageVOY from './SupportSheetOnVoyageVOY';
import SupportSheetPostVoyage from './SupportSheetPostVoyage';
import FixturePreview from '../FixtureManagement/FixturePreview';
import SupportSheetOnVoyageTCT from './SupportSheetOnVoyageTCT';
import SupportSheetPrincipleModal from './components/SupportSheetPrinciple/SupportSheetPrincipleModal';
import SupportSheetHelpTextModal from './components/SupportSheetHelpText/SupportSheetHelpTextModal';
import CompanyNamePICApi from '../CompanyNamePIC/api/CompanyNamePICApi';
import CompanyNamePICModel from '../CompanyNamePIC/models/CompanyNamePICModel';
import BaseResponse from '../../app/BaseResponse';
import { setCompanyNamePICSearchResults } from '../CompanyNamePICSelector/reducers/CompanyNamePICSelectorReducer';
import SupportSheetApi, { GetSupportSheetAndFixtureByIdResponse, GetSupportSheetByIdParam } from './api/SupportSheetApi';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import CommissionItemModel from '../FixtureManagement/components/FixtureCommissionDetail/models/CommissionItemModel';
import UserApi from '../UserManagement/api/UserApi';
import UserDisplayNameModel from '../UserSelector/models/UserDisplayNameModel';

const SupportSheet: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const supportSheetData = useSelector(SupportSheetSelector);

    useEffect(() => {
        loadSupportSheet()
    }, []);

    const loadUsers = (callBack: (users: UserDisplayNameModel[]) => void) => {
        UserApi.GetDisplayNames()
            .then((response: BaseResponse<UserDisplayNameModel[]>) => {
                if (response.success) {
                    callBack(response.data);
                } else {
                    Utility.Alert.Error(response.message);
                }
            }).catch((error) => {
                Utility.Alert.Error(error);
            })
    }

    const mapBrokerCommDetailEmails = (comRateDetail: string) => {
        loadUsers((users) => {
            let commissions = JSON.parse(comRateDetail) as CommissionItemModel[];
            let emails = "";
            _.each(commissions, (commission) => {
                let broker = _.find(users, (user) => {
                    return user.id === commission.brokerId;
                })

                if (broker && broker.workingEmail) {
                    emails += broker.workingEmail + ";"
                }
            });

            dispatch(setBrokerEmails(emails));
        })
    }

    const loadSupportSheet = () => {

        const urlParams = new URLSearchParams(window.location.search);

        let fixtureId = urlParams.get("fixtureId");

        SupportSheetApi.GetById({
            id: fixtureId
        } as GetSupportSheetByIdParam)
            .then((response: BaseResponse<GetSupportSheetAndFixtureByIdResponse>) => {
                if (response.success) {
                    dispatch(setCurrentFixture(response.data.fixture));
                    dispatch(setSupportSheet(response.data.supportSheet));

                    setPrincileDataForUI(response.data.supportSheet);

                    mapBrokerCommDetailEmails(response.data.fixture.commRateDetail);

                    if (response.message.length > 0) {
                        Utility.Alert.Error(response.message);
                    }

                    document.title = response.data.fixture.tonnageVesselName + "-" + Utility.DateFormat.formatDateString(response.data.fixture.cpDate);

                } else {
                    Utility.Alert.Error(response.message);
                }
            }).catch((error) => {
                Utility.Alert.Error(error);
            })
            .finally(() => {
                dispatch(showLoading(false));
            });
    }

    const setPrincileDataForUI = (currentSupportSheet: SupportSheetModel) => {
        if ((currentSupportSheet.ownerBrokerPrincipleId !== null && currentSupportSheet.ownerBrokerPrincipleId.length > 0) ||
            (currentSupportSheet.chartererBrokerPrincipleId !== null && currentSupportSheet.chartererBrokerPrincipleId.length > 0)) {
            CompanyNamePICApi.GetAll()
                .then((response: BaseResponse<CompanyNamePICModel[]>) => {
                    if (response.success) {
                        dispatch(setCompanyNamePICSearchResults(response.data))

                        let ownerBroker = _.find(response.data, (item) => {
                            return item.id == currentSupportSheet.ownerBrokerPrincipleId;
                        })

                        if (ownerBroker) {
                            dispatch(setOwnerBrokerContactPrinciple(ownerBroker));
                        }

                        let chartererBroker = _.find(response.data, (item) => {
                            return item.id == currentSupportSheet.chartererBrokerPrincipleId;
                        })

                        if (chartererBroker) {
                            dispatch(setChartererBrokerContactPrinciple(chartererBroker));
                        }
                    } else {
                        Utility.Alert.Error(response.message);
                    }
                }).catch((error) => {
                    Utility.Alert.Error(error);
                })
                .finally(() => {
                    dispatch(showLoading(false));
                })
        }
    }

    return (
        <>
            {
                supportSheetData.currentFixture && supportSheetData.model &&
                <Grid container className="support-sheet">
                    <Grid item lg={3} xs={12} className="left-info-area">
                        <SupportSheetBiefInformation></SupportSheetBiefInformation>
                    </Grid>
                    <Grid item lg={9} xs={12} className="right-content">
                        <SupportSheetPreVoyage></SupportSheetPreVoyage>
                        {
                            (supportSheetData.currentFixture.bizType == MarketInfoType.Voy || supportSheetData.currentFixture.bizType == MarketInfoType.COA) &&
                            <SupportSheetOnVoyageVOY></SupportSheetOnVoyageVOY>
                        }
                        {
                            (supportSheetData.currentFixture.bizType == MarketInfoType.TCT || supportSheetData.currentFixture.bizType == MarketInfoType.TC) &&
                            <SupportSheetOnVoyageTCT></SupportSheetOnVoyageTCT>
                        }
                        <SupportSheetPostVoyage></SupportSheetPostVoyage>
                    </Grid>
                </Grid>
            }
            {
                supportSheetData.isDataChange &&
                <>
                    <div className='support-sheet-save-change'>
                        <Button
                            className='support-sheet-save-change-button'
                            variant='contained' color='primary'
                            onClick={() => {
                                SupportSheetApi.Save(supportSheetData.model)
                                    .then((response: BaseResponse<string>) => {
                                        if (response.success) {
                                            Utility.Alert.Success("Save successful");

                                            dispatch(resetDataChange());
                                        } else {
                                            dispatch(showLoading(false));
                                            Utility.Alert.Error(response.message);
                                        }
                                    })
                                    .catch((error) => {
                                        dispatch(showLoading(false));
                                        Utility.Alert.Error(error);
                                    });
                            }}
                        >
                            Save Changes
                        </Button>
                    </div>
                </>
            }
            <SupportSheetPrincipleModal>
            </SupportSheetPrincipleModal>
            <FixturePreview></FixturePreview>
            <SupportSheetHelpTextModal></SupportSheetHelpTextModal>
        </>
    )
};

export default SupportSheet;